import { useCallback, useEffect, useState } from 'react';

import { cn } from '@utils/cn';

import { Button } from '@ui-component-library/components/Button';

import { buttonWrapperClasses, selectWrapperClasses, tabsWrapperClasses } from './Tabs.styles';
import type { TabsProps } from './Tabs.types';

export const Tabs = ({ tabs, value, onChange, variant = 'default', className }: TabsProps) => {
  const [isMobile, setIsMobile] = useState(false);

  const handleTabClick = (tabValue: string) => {
    if (onChange) {
      onChange(tabValue);
    }
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleTabClick(event.target.value);
  };
  const handleResize = useCallback(() => {
    // In an extremely small screen
    setIsMobile(window.innerWidth < 361);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      handleResize();
    }, 0);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  // Will update the Dropdown when we have a new Dropdown component
  if (isMobile) {
    return (
      <div className={cn(tabsWrapperClasses({ variant }), className)}>
        <select
          value={value}
          onChange={handleSelectChange}
          className={cn(selectWrapperClasses(), className)}
        >
          {tabs.map((tab) => (
            <option key={tab.value} value={tab.value}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className={cn(tabsWrapperClasses({ variant }), className)}>
      {tabs.map((tab) => {
        const isActive = value === tab.value;
        return (
          <Button
            key={tab.value}
            variant={isActive ? 'outline' : 'tertiary'}
            onClick={() => handleTabClick(tab.value)}
            size="xsmall"
            aria-selected={isActive}
            className={cn(buttonWrapperClasses({ isActive, variant }), className)}
          >
            {tab.label}
          </Button>
        );
      })}
    </div>
  );
};
